import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const AddMonitoringContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AddMonitoringProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        `user_monitoring/${id}/set-interval`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <AddMonitoringContext.Provider value={contextValue}>
      {children}
    </AddMonitoringContext.Provider>
  );
};

export default AddMonitoringProvider;
